import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Transition, { name: "opacity" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b()),
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)), ["self"]))
          }, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(_ctx.b('wrapper'))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.b('close')),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.b('close-icon')),
                  innerHTML: _ctx.displayedCloseIcon
                }, null, 10, _hoisted_1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('content'))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('instructions'))
                }, [
                  _createElementVNode("h3", {
                    class: _normalizeClass(_ctx.b('title'))
                  }, _toDisplayString(_ctx.$t("Пожалуйста, сделайте селфи, ориентируясь на пример.")), 3),
                  _createElementVNode("ul", {
                    class: _normalizeClass(_ctx.b('list'))
                  }, [
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("На фотографии должно быть чётко видно ваше лицо целиком — лоб, глаза, нос и подбородок не должны быть обрезаны или закрыты.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t('В одной руке держите документ, выбранный на предыдущем шаге (паспорт, ID ), так чтобы было видно фото и основные данные.')), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t('В другой руке держите лист бумаги, на котором от руки написаны текущая дата, текст LLC "MEX" и ваша подпись.')), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Лицо, документ и лист с текстом должны быть одновременно в одном кадре.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Фото должно быть сделано при хорошем освещении, без теней и затемнений.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Избегайте бликов на документе — данные должны быть читаемы.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Не используйте фильтры, маски, ретушь или портретный режим камеры.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Фотография должна быть резкой, без смаза и следов редактирования.")), 3),
                    _createElementVNode("li", {
                      class: _normalizeClass(_ctx.b('item'))
                    }, _toDisplayString(_ctx.$t("Скриншоты, коллажи и фотографии с экрана не принимаются.")), 3)
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('example'))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(_ctx.b('example-image')),
                    src: _ctx.exampleImageSrc,
                    alt: "Пример селфи с паспортом"
                  }, null, 10, _hoisted_2)
                ], 2)
              ], 2)
            ], 2)), [
              [_directive_click_outside, _ctx.handleClose]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}